export const MethodBadgeGet = () => (
  <span className="inline-block w-16 rounded bg-[var(--color-info-bg)] px-2 py-1 text-center text-xs font-bold text-[var(--color-info-text)]">
    GET
  </span>
);
